import { useEffect, useState } from 'react';
import { userService } from "services";

const useSpeclialisedList = () => {
    const [speclialisedList, setSpeclialisedList] = useState([]);

    const handleApi = async () => {
        try {
            const response = await userService.getSpeclialisedList();
            setSpeclialisedList(response.data.data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        handleApi();
    }, []);

    return { speclialisedList };
}

export default useSpeclialisedList;